import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { buildMetricsFilters, getFilterHash } from 'features/metrics/metricsActions';
import { fetchSmartCardsVds } from 'features/frontoffice/actions/smartCardVdsActions';

/**
 * Triggers a /tbl/sc-vds refresh whenever the applied global filters change.
 * Gated on a resolved tenant and seeded filters, mirroring useAllMetrics.
 */
export const useSmartCardVdsTrigger = () => {
  const dispatch = useDispatch();
  const tenantCd = useSelector((state) => state.user?.currentTenantCd);
  const applied = useSelector((state) => state.globalFilters?.applied);
  const defaultsSeeded = useSelector((state) => state.globalFilters?.defaultsSeeded);

  const filterHash = useMemo(
    () => getFilterHash(buildMetricsFilters(applied)),
    [applied]
  );

  useEffect(() => {
    if (!tenantCd || !defaultsSeeded) return;
    dispatch(fetchSmartCardsVds());
  }, [dispatch, tenantCd, defaultsSeeded, filterHash]);
};
